import { render, staticRenderFns } from "./EquipmentReduce.vue?vue&type=template&id=745c97e0&scoped=true&"
import script from "./EquipmentReduce.vue?vue&type=script&lang=js&"
export * from "./EquipmentReduce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745c97e0",
  null
  
)

export default component.exports